import React from "react";
import { NavLink } from "react-router-dom";

import "./sidebar.scss";
import { useTranslation } from "react-i18next";
const Sidebar = (props) => {
  const { t } = useTranslation();
  const { show } = props;
  return (
    <div className={`App sidebar-main ${show ? "shownav" : "hidenav"}`}>
      <nav className="linksparent">
        {JSON.parse(localStorage.getItem("menuStructure"))
          ?.filter(
            (item) =>
              item.parentId === null &&
              !item?.applicationKey?.includes("FutureCare") &&
              item.componentName != "Products"
          )
          .map((item) => (
            <NavLink
              className="menu-linkk"
              to={`${item.route}`}
              key={item.route}
            >
              <img
                style={{ width: "30px" }}
                src={`/assets/icons/${item.componentName + ".svg"}`}
                alt="image"
              />
              <span className="heading-smb"> {t(item.componentName)}</span>
            </NavLink>
          ))}
      </nav>
    </div>
  );
};

export default Sidebar;
